/* Component Dependencies */
var rewardsLogoMrTemplate = require('templates/rewardsLogo-mr.hbs');
var rewardsLogoGuestInfoMRTemplate = require('templates/rewardsLogo-guestInfoMR.hbs');
var rewardsLogoGuestInfoRCRTemplate = require('templates/rewardsLogo-guestInfoRCR.hbs');
var rewardsLogoRcrTemplate = require('templates/rewardsLogo-rcr.hbs');
var rewardsLogoProgramInfoMrTemplate = require('templates/rewardsLogo-programInfoMr.hbs');
var rewardsLogoProgramInfoRcrTemplate = require('templates/rewardsLogo-programInfoRcr.hbs');
var rewardsLogoGuestInfoErsTemplate = require('templates/rewardsLogo-guestInfoErs.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'rewardsLogo',
  template: {
    'rewardsLogo-mr': rewardsLogoMrTemplate,
    'rewardsLogo-guestInfoMR': rewardsLogoGuestInfoMRTemplate,
    'rewardsLogo-guestInfoRCR': rewardsLogoGuestInfoRCRTemplate,
    'rewardsLogo-rcr': rewardsLogoRcrTemplate,
    'rewardsLogo-programInfoMr': rewardsLogoProgramInfoMrTemplate,
    'rewardsLogo-programInfoRcr': rewardsLogoProgramInfoRcrTemplate,
    'rewardsLogo-guestInfoErs': rewardsLogoGuestInfoErsTemplate
  }
});
